import React, { useMemo } from "react";
import { PrintLayoutModalContainer } from "@/pages/tech/layouts/PrintLayoutModalContainer";

export interface GangRunItem {
  id: string;
  detailId?: string;
  orderId?: string;
  orderCode?: string;
  customerPo?: string | null;
  customerId?: string | null;
  customerName?: string | null;
  productId?: string | null;
  productCode?: string | null;
  productName: string;
  quantity: number;
  flatLength?: number | null;
  flatWidth?: number | null;
  materialId?: string | null;
  materialName?: string | null;
  image?: string | null;
  ups: number;
  printSheets?: number;
  allowancePercent?: number | null;
}

export interface GangRunImpositionModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  orderDetail?: any;
  selectedItems?: any[];
  orderCode?: string;
  customerId?: string;
  customerName?: string;
  layoutId?: string | null;
  mode?: "create" | "edit";
  focusField?: "code" | "sheetSize" | "ups" | "sheets" | null;
  onSuccess: () => void | Promise<void>;
}

/**
 * GangRunImpositionModal — Rule 2 Canonical Form Delegation Wrapper.
 * Toàn bộ nghiệp vụ Bình file / Ghép bài / Tách bài ủy quyền 100% về PrintLayoutModalContainer + PrintLayoutForm.
 */
export function GangRunImpositionModal({
  open,
  onOpenChange,
  orderDetail,
  selectedItems,
  orderCode,
  layoutId = null,
  mode = "create",
  focusField = null,
  onSuccess,
}: GangRunImpositionModalProps) {
  const initialDetails = useMemo(() => {
    if (selectedItems && selectedItems.length > 0) return selectedItems;
    if (orderDetail) return [orderDetail];
    return [];
  }, [orderDetail, selectedItems]);

  return (
    <PrintLayoutModalContainer
      open={open}
      onOpenChange={onOpenChange}
      mode={mode}
      layoutId={layoutId}
      initialDetails={initialDetails}
      orderId={
        orderDetail?.orderId ||
        orderDetail?.order?.id ||
        selectedItems?.[0]?.orderId ||
        selectedItems?.[0]?.order?.id ||
        null
      }
      orderCode={orderCode || null}
      focusField={focusField}
      onSuccess={async () => {
        await onSuccess();
      }}
    />
  );
}
